import { render, staticRenderFns } from "./PlaylistStudentItemCard.vue?vue&type=template&id=50b8771d&scoped=true&"
import script from "./PlaylistStudentItemCard.vue?vue&type=script&lang=ts&"
export * from "./PlaylistStudentItemCard.vue?vue&type=script&lang=ts&"
import style0 from "./PlaylistStudentItemCard.vue?vue&type=style&index=0&id=50b8771d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b8771d",
  null
  
)

export default component.exports